// extracted by mini-css-extract-plugin
module.exports = {"form":"RecurringRuleModal_form__2dyv4","fullWidthItem":"RecurringRuleModal_fullWidthItem__20Nd-","checkboxRow":"RecurringRuleModal_checkboxRow__3RK8v"};